import React, { useState } from 'react';
import axios from '../api/api';
import { toast } from 'sonner';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../components/images/cf-logo-300x169.png'
import PropTypes from 'prop-types';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Register = () => {

  const [company_name, setCompany_name] = useState('');
  const [user_name, setUser_name] = useState('');
  const [first_name, setFirst_name] = useState('');
  const [last_name, setLast_name] = useState('');
  const [email_address, setEmail_address] = useState('');
  const [phone_number, setPhone_number] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [pincode, setPincode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email_code,SetEmail_code] = useState('')
  const [phone_code,SetPhone_code] = useState('')

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  }

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  }

  const sendCode = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/security/registration-code', {
        email_address, phone_number
      })
      toast.success('Registration code sent to email and phone.')
    } catch (error) {
      console.log(error);
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to send code.')
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email_code || !phone_code) {
      return toast.error('Email and phone code are required!')
    }
    if (password.length < 8) {
      toast.error('Password must have a minimum of 8 characters')
      return
    }
    if (password !== confirmpassword) {
      toast.error('Passwords do not match')
      return
    }
    setLoading(true);
    try {
      await axios.post('/auth/register',
        { company_name, user_name, first_name, last_name, email_code, phone_code,
          email_address, phone_number, address, city, state, pincode, password 
        }
      );
      toast.success('Register Sucessful');
      navigate('/login');
    } catch (error) {
      console.log(error);
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Registration failed.')
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <div className='flex flex-wrap items-center justify-center gap-4 h-screen md:h-screen lg:h-[100vh]'>
        <div className='bg-white p-4 rounded-lg w-full xl:w-1/2 2xl:w-1/3'>
          <form onSubmit={handleSubmit}>
            <div className='p-2'>
              <span><img className='w-40' src={logo} alt="logo" /></span>
              <h3 className='font-bold'>Sign up to credo faster</h3>
              <p>Enter the company details below</p>
            </div>
            <div className="flex flex-wrap items-center">
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='company'><span>Company Name</span> <span className="text-red-500">*</span>
                  <input
                    type='text'
                    required
                    placeholder='Company Name'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={company_name}
                    onChange={(e) => setCompany_name(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='username'><span>Username</span> <span className="text-red-500">*</span>
                  <input
                    type='text'
                    required
                    placeholder='User Name'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={user_name.replace(/\s+/g, '')}
                    onChange={(e) => setUser_name(e.target.value)}
                  />
                </label>
              </div>
            </div>
            <div className="flex flex-wrap items-center">
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='fname'><span>First Name</span> <span className="text-red-500">*</span>
                  <input
                    type='text'
                    required
                    placeholder='First Name'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={first_name}
                    onChange={(e) => setFirst_name(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='lname'><span>Last Name</span> <span className="text-red-500">*</span>
                  <input
                    type='text'
                    required
                    placeholder='Last Name'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={last_name}
                    onChange={(e) => setLast_name(e.target.value)}
                  />
                </label>
              </div>
            </div>
            <div className="flex flex-wrap items-center">
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='email'><span>Email</span> <span className="text-red-500">*</span>
                  <input
                    type='email'
                    required
                    placeholder='Email Address'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={email_address}
                    onChange={(e) => setEmail_address(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='phone'><span>Phone Number</span> <span className="text-red-500">*</span>
                  <input
                    type='number'
                    required
                    placeholder='070000000'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={phone_number}
                    onChange={(e) => setPhone_number(e.target.value)}
                  />
                </label>
              </div>
            </div>
            <div className="flex flex-wrap items-center">
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='address'><span>Address</span> <span className="text-red-500">*</span>
                  <input
                    type='text'
                    required
                    placeholder='Address'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='city'><span>City</span> <span className="text-red-500">*</span>
                  <input
                    type='text'
                    required
                    placeholder='City'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </label>
              </div>
            </div>
            <div className="flex flex-wrap items-center">
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='state'><span>State</span> <span className="text-red-500">*</span>
                  <input
                    type='text'
                    required
                    placeholder='State'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-2 w-full lg:w-1/2'>
                <label htmlFor='pincode'><span>Pin Code</span> <span className='text-slate-400'>(Optional)</span>
                  <input
                    type='text'
                    placeholder='Pin Code'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                  />
                </label>
              </div>
            </div>
            <div className="flex flex-wrap items-center">
              <div className="p-2 w-full lg:w-1/2 relative">
                <label htmlFor="password" className="block">
                  <span>Password <span className="text-red-500">*</span> <i className='text-red-500'>(Min 8 characters)</i></span>
                  <div className="flex items-center">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      required
                      placeholder="********"
                      className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className="absolute right-4 text-sm text-[#165277] focus:outline-none"
                      style={{ top: '65%', transform: 'translateY(-50%)' }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </label>
              </div>
              <div className="p-2 w-full lg:w-1/2 relative">
                <label htmlFor="confirmpassword" className="block">
                  <span>Confirm Password <span className="text-red-500">*</span> <i className='text-red-500'>(Min 8 characters)</i></span>
                  <div className="flex items-center">
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      required
                      placeholder="********"
                      className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                      value={confirmpassword}
                      onChange={(e) => setConfirmpassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={toggleConfirmPasswordVisibility}
                      className="absolute right-4 text-sm text-[#165277] focus:outline-none"
                      style={{ top: '65%', transform: 'translateY(-50%)' }}
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </label>
              </div>
            </div>
            <div className="flex flex-wrap items-center">
              <div className='p-2 w-full lg:w-1/3'>
                <label htmlFor='email_code'>
                  <input
                    type='number'
                    placeholder='Email Code'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={email_code}
                    onChange={(e) => SetEmail_code(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-2 w-full lg:w-1/3'>
                <label htmlFor='phone_code'>
                  <input
                    type='number'
                    placeholder='Phone Code'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={phone_code}
                    onChange={(e) => SetPhone_code(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-2 w-full lg:w-1/3'>
                <button disabled={loading} onClick={sendCode} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md w-full hover:bg-[#165277] disabled:bg-slate-500'>{loading ? 'Sending Code...' : 'Get Code'}</button>
              </div>
            </div>
            <div className='my-2'>
              <button disabled={loading} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md w-full hover:bg-[#165277] disabled:bg-slate-500'>{loading ? 'Please Wait...' : 'Register'}</button>
            </div>
            <div>
              <h5>Already have an account? <Link to='/login'><u className="hover:text-[#165277]">Login</u></Link></h5>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Register;

Register.propTypes = {
  setAccessToken: PropTypes.func
};
